import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  TextField,
  Grid,
  Typography,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import {
  getOtherPartyListDiscrepancy,
  getDiscrepancyList,
  ReconcileAction,
} from "../../actions/settlementActions";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
const ListWithDiscrepancies = () => {
  const navigate = useNavigate();
    const redirect = (row) => {
      navigate(`/app/management/discrepancies-details`, { state: { row } });
    };
  const dispatch = useDispatch();
  const businessInfo = useSelector((state) => state?.app?.businessInfo);
  const customerId = businessInfo?.customerId;

  const [selectedIds, setSelectedIds] = useState([]);
  const [list, setList] = useState([]);
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [selectedValue, setSelectedValue] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  // Fetch party list on mount
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const roleResult = await dispatch(getOtherPartyListDiscrepancy());
        setList(roleResult || []);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };
    fetchInitialData();
  }, [dispatch, customerId]);

  const type = "DISCREPENCY";

  const handleReceiverChange = async (event, newValue) => {
    if (newValue) {
      try {
        setLoading(true);
        const data = await dispatch(getDiscrepancyList(type, newValue));
        setData(data);
        setSelectedValue(newValue);
      } catch (error) {
        console.error("Error fetching discrepancy list:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleReconcile = async () => {
  try {
    const bapId = selectedValue; 
    // collect all settlementIds into one array
    const settlementIds = selectedRows.map((item) => item?.settlementId);
    const payload = {
      bapId,
      settlementList: settlementIds,
    };

    console.log("Payload sending for reconcile:", payload);

    // Pass payload correctly
    const res = await dispatch(ReconcileAction(payload));

    if (res?.data?.message) {
      setMsg(res.data.message);
      setDialogOpen(true);
      selectedRows([]);
      setTimeout(() => {
        setDialogOpen(false);
        setMsg("");
      }, 3000);
    }
  } catch (error) {
    console.error("Error sending reconcile:", error);
  }
};


  // DataGrid columns
  const columns = [
  { field: "settlementId", headerName: "Settlement ID", flex: 1 },
  {
    field: "context",
    headerName: "BPP ID",
    flex: 1,
    valueGetter: ({ row }) => row?.context?.bpp_id,
  },
  { field: "creationType", headerName: "Creation Type", flex: 1 },
  {
    field: "settlementStatus",
    headerName: "Settlement Status",
    flex: 1,
  },
  {
    field: "createdAt",
    headerName: "Created At",
    flex: 1,
    valueGetter: ({ row }) =>
      row?.createdAt ? new Date(row.createdAt).toLocaleString() : "",
  },
  {
    field: "updatedAt",
    headerName: "Updated At",
    flex: 1,
    valueGetter: ({ row }) =>
      row?.updatedAt ? new Date(row.updatedAt).toLocaleString() : "",
  },
  {
    field: "orderId",
    headerName: "Order ID",
    flex: 1,
    valueGetter: ({ row }) => row?.orders?.[0]?.id, // first order id
  },
  {
    field: "collectedAmount",
    headerName: "Collected Amount",
    flex: 1,
    valueGetter: ({ row }) => row?.orders?.[0]?.collector?.amount?.value,
  },
  {
    field: "discrepancyAmount",
    headerName: "Discrepancy Amount",
    flex: 1,
    valueGetter: ({ row }) =>
      row?.discrepancies?.[0]?.settled_amount?.value,
  },
  {
        field: "action",
        disableClickEventBubbling: true,
        headerName: "Action",
        renderCell: (params) => {
          const redirectToView = () => {
            redirect(params.row);
          };
  
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center", // vertical center alignment
                justifyContent: "flex-start",
                gap: 1,
              }}
            >
              <Tooltip title="View details">
                <Box sx={{ cursor: "pointer" }} onClick={redirectToView}>
                  <RemoveRedEyeRoundedIcon />
                </Box>
              </Tooltip>
              {/* <Tooltip title="View details">
                <Box sx={{ cursor: "pointer" }} onClick={redirectToEdit}>
                  <EditIcon />
                </Box> 
              </Tooltip>*/}
            </Box>
          );
        },
        flex: 1,
      },
];


  return (
    <Box
      sx={{
        maxWidth: "100%",
        padding: 4,
        borderRadius: 2,
        margin: "auto",
        marginTop: 4,
        backgroundColor: "#fff",
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h3" color="textPrimary">
            Settlement List With Discrepancies
          </Typography>
        </Grid>

        {/* Party Selector */}
        <Grid item xs={12} md={6}>
          <Autocomplete
            options={list}
            value={selectedValue}
            onChange={handleReceiverChange}
            getOptionLabel={(option) => option || ""}
            renderInput={(params) => (
              <TextField {...params} label="Other Party" fullWidth />
            )}
          />
        </Grid>

        {/* DataGrid */}
        <Grid item xs={12}>
         
          <div style={{ height: 500, width: "100%" }}>
            <DataGrid
              rows={data}
              columns={columns}
              loading={loading}
              getRowId={(row) => row._id}
              checkboxSelection
              disableRowSelectionOnClick
              selectionModel={selectedIds}
              onSelectionModelChange={(newSelection) => {
                setSelectedIds(newSelection);
                const selectedData = data.filter((row) =>
                  newSelection.includes(row._id)
                );
                setSelectedRows(selectedData);
                console.log("Selected rows:", selectedData);
              }}
            />
          </div>
        </Grid>

        {/* Reconcile Button */}
        <Grid item xs={12} sx={{ textAlign: "left", mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleReconcile}
            disabled={selectedRows.length === 0}
          >
            Send For Reconcile
          </Button>
        </Grid>
      </Grid>

      {/* Dialog for messages */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Reconcile</DialogTitle>
        <DialogContent>
          <Typography>{msg}</Typography>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ListWithDiscrepancies;
